import { Link } from 'react-router-dom';
import { ShieldIcon, ZapIcon, LifeBuoyIcon } from '../components/icons';
import Circles from '../components/circles';
import Herosection from '../components/herosection';
import Advancedoptions from '../components/advancedoptions';
import ServiceTabs from '../components/service';
import Perfectoffers from '../components/perfectoffers';
import FactsSection from '../components/facts';
import TestimonialsSection from '../components/testimonials';
import LinuxHostingSection from '../components/linux';
import Quickstart from '../components/quickstart';
import BrowserCompatibility from '../components/browsercompat';
import Apps from '../components/apps';
import React from "react";
import KasperskyPartner from '../components/kaspersky';
export default function Home() {

  
  return (
    <div>
      <Herosection />
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16 grid md:grid-cols-2 gap-8 md:gap-10 items-center">
          <div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              Domains and Cloud Hosting that scale with you
            </h1>
            <p className="mt-4 text-gray-600">
              Find the perfect domain and launch blazing-fast sites on our reliable cloud.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <Link to="/domains" className="px-5 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-center">Find a domain</Link>
              <Link to="/hosting" className="px-5 py-3 border rounded-lg text-gray-700 hover:text-blue-600 text-center">View hosting</Link>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
            <div className="p-6 bg-blue-50 rounded-xl shadow-sm">
              <ZapIcon className="mx-auto h-10 w-10 text-blue-600" />
              <p className="mt-2 font-medium text-gray-800">High Performance</p>
            </div>
            <div className="p-6 bg-blue-50 rounded-xl shadow-sm">
              <ShieldIcon className="mx-auto h-10 w-10 text-blue-600" />
              <p className="mt-2 font-medium text-gray-800">Secure</p>
            </div>
            <div className="p-6 bg-blue-50 rounded-xl shadow-sm">
              <LifeBuoyIcon className="mx-auto h-10 w-10 text-blue-600" />
              <p className="mt-2 font-medium text-gray-800">24/7 Support</p>
            </div>
          </div>
        </div>
      </section>
      <Circles />
      <Advancedoptions />
      <ServiceTabs />
      <Perfectoffers />
      <KasperskyPartner />
      <FactsSection />
      <TestimonialsSection />
      <LinuxHostingSection />
      <Quickstart />
      <BrowserCompatibility/>
      <Apps/>
    </div>
  );
}


